import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function footer() {
  return (
    <div>
      <div className="footer">
        <Container>
          <Row>
            <Col className="text-center">
              <p>
                <span>&#169;</span> Copyright <span id="spFY"></span> All rights
                reserved by Pramodaya | Develop and Design by{" "}
                <a className="adyah" href="https://www.adyah.co.in/">
                  Adyah Consultancy Services
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default footer;
